import { createStore } from 'satcheljs';
export default createStore('readReceiptOption', {
    readReceiptResponse: null,
})();
//# sourceMappingURL=store.js.map